export default "dist/images/block-blockquote-centered-quote.d743590.png";